<div *ngIf="data?.employee" class="card employee-card position-relative">
  <!-- Ribbon -->
  <div class="ribbon">
    <span>{{ 'Employee of the Month' | translate }}</span>
  </div>

  <!-- Avatar Image -->
  <div class="avatar-container">
    <img 
      *ngIf="data.employee.image" 
      [src]="data.employee.image" 
      [alt]="data.employee.full_name + ' Avatar'" 
      class="avatar">
    <img 
      *ngIf="!data.employee.image" 
      src="assets/images/placeholder-user.jpg" 
      [alt]="data.employee.full_name + ' Avatar'" 
      class="avatar">
  </div>

  <!-- Card Body -->
  <div class="card-body">
    <span class="help-icon fas fa-info-circle"
        [ngbTooltip]="tooltip.text | translate"
        [placement]="tooltip.placement"
        container="body"></span>
    <h5 class="card-title">{{ data.employee.full_name }}</h5>
    <p class="card-text">{{ data.employee.position || 'Position not available' }}</p>
    <div class="info-box info-composite bg-danger monthly-score">
      {{ 'Employee monthly score' | translate }}: {{ data.employee.compositeScore || 0 }}%
    </div>
    <p class="card-text">
      {{ (data.employee.full_name + ' has shown exceptional performance this month, demonstrating outstanding skills and dedication.') | translate }}
    </p>

    <!-- Colorful Info Boxes -->
    <div class="mt-4">
      <div class="info-box info-progress bg-primary">
        {{ 'Objective Progress' | translate }}: {{ data.employee.objectiveProgress || 0 }}%
      </div>
      <div class="info-box info-assessment bg-success">
        {{ 'Assessment Score' | translate }}: {{ data.employee.assessmentScore || 0 }}%
      </div>
      <div class="info-box info-skill bg-warning">
        {{ 'Skill Improvement' | translate }}: {{ data.employee.skillImprovement || 0 }}%
      </div>
      <div class="info-box info-training bg-info">
        {{ 'Training Progress' | translate }}: {{ data.employee.trainingProgress || 0 }}%
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button class="btn btn-link btn-edit" (click)="openModal()">
      <i class="fa fa-edit"></i> {{ 'Set Metrics' | translate }}
    </button>
    <!-- Employee of the Month Ranking Button -->
    <button class="btn btn-link btn-ranking" (click)="openRankingModal()">
      <i class="fas fa-trophy"></i> {{ 'View Ranking' | translate }}
    </button>
  </div>
</div>


<!-- Employee of the Month Ranking Modal -->
<ng-template #rankingModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-award"></i> {{ 'Employee of the Month Rankings' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="ranking-container">
      <table class="table table-hover ranking-table">
        <thead>
          <tr>
            <th>{{ '#' }}</th>
            <th>{{ 'Employee' | translate }}</th>
            <th>{{ 'Position' | translate }}</th>
            <th>{{ 'Monthly Score' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let employee of data.topEmployees; let i = index" [ngClass]="{'gold-rank': i === 0, 'silver-rank': i === 1, 'bronze-rank': i === 2}">
            <td>
              <span class="rank-badge">{{ i + 1 }}</span>
            </td>
            <td class="employee-info">
              <img [src]="employee.image ? employee.image : 'assets/images/placeholder-user.jpg'" class="employee-avatar">
              {{ employee.full_name }}
            </td>
            <td>{{ employee.position || 'N/A' }}</td>
            <td><strong>{{ employee.compositeScore || 0 }}%</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">{{ 'Close' | translate }}</button>
  </div>
</ng-template>

<!-- Bootstrap Modal -->
<ng-template #metricModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'Select Metrics & Assign Weightage' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <ng-container *ngFor="let metric of availableMetrics">
      <div class="metric-row">
        <!-- Checkbox -->
        <div class="form-check d-flex align-items-center">
          <input class="form-check-input" type="checkbox" [(ngModel)]="metric.selected" (change)="onCheckboxChange(metric)" id="{{metric.name}}">
          <label class="form-check-label ms-2" for="{{metric.name}}">{{ metric.name }}</label>
        </div>
  
        <!-- Weightage Input (Visible only when selected) -->
        <div *ngIf="metric.selected" class="weightage-input">
          <input type="number" class="form-control" [(ngModel)]="metric.weightage" placeholder="Enter Weightage (%)" min="0" max="100">
        </div>
      </div>
    </ng-container> 
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">{{ 'Cancel' | translate }}</button>
    <button class="btn btn-primary" (click)="saveMetrics()">{{ 'Save' | translate }}</button>
  </div>
</ng-template>
